import { Injectable } from '@angular/core';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import { ITopLevelKeys } from '../entity-data/entity-data.data';
import { EntityDataService } from '../entity-data/entity-data.service';
import { ErrorService } from '../error-reporting/error.service';
import { GlobalSearch } from '../search-data/global-search.model';
import { SettingsDataStore } from '../settings-data/settings-data.store';
import { LoggerService } from '../shared/services/logger/logger.service';
import { TrackedTimeDataBuilder } from './tracked-time-data.builder';
import { Observable } from 'rxjs';
import { TrackedTimeFilters } from './models/tracked-time-filters.model';
import { IResponseInfo } from '../http/http.data';
import { TrackedTimeFiltersEnum } from './tracked-time-data.data';
import { map } from 'rxjs/operators';

export const TRACKED_TIME_URL = '/tracked_times';
export const TRACKED_TIME_FILTER_ACCEPT_VERSION = '1.0.0';
export const TRACKED_TIME_SEARCH_ACCEPT_VERSION = '1.0.0';
export const TRACKED_TIME_ACCEPT_VERSION = '1.0.0';

@Injectable()
export class TrackedTimeDataService extends EntityDataService {
  protected inputHeaders: any = {
    [ACCEPT_VERSION_HEADER]: TRACKED_TIME_ACCEPT_VERSION,
  };
  protected filtersHeaders: any = {
    [ACCEPT_VERSION_HEADER]: TRACKED_TIME_FILTER_ACCEPT_VERSION,
  };
  protected searchHeaders: any = {
    [ACCEPT_VERSION_HEADER]: TRACKED_TIME_SEARCH_ACCEPT_VERSION,
  };

  trackedTimesUrl: string = TRACKED_TIME_URL;
  topLevelKeys: ITopLevelKeys = {
    getKey: 'tracked_times',
    postKey: 'created_tracked_time',
    putKey: 'updated_tracked_time',
    deletedKey: 'deleted_tracked_times',
    deleteSingleKey: 'deleted_tracked_time',
    getSingleKey: 'tracked_time',
    searchResultsKey: 'tracked_time_results',
    globalSearchResultsKey: GlobalSearch.KEYS.TRACKED_TIMES,
  };

  constructor(
    authHttpService: AuthHttpService,
    loggerService: LoggerService,
    errorService: ErrorService,
    trackedTimeDataBuilder: TrackedTimeDataBuilder,
    settingsDataStore: SettingsDataStore
  ) {
    super(
      authHttpService,
      TRACKED_TIME_URL,
      loggerService,
      errorService,
      trackedTimeDataBuilder,
      settingsDataStore
    );
  }

  getFilters(
    listFilter: TrackedTimeFiltersEnum
  ): Observable<TrackedTimeFilters> {
    const params = { list_category: listFilter };
    const url = `${this.entitiesUrl}/filters`;

    return this.authHttpService
      .get(url, params, this.filtersHeaders)
      .pipe(
        map(({ body, ..._ }: IResponseInfo) => new TrackedTimeFilters(body))
      );
  }
}
